// Büyüme Merkezi alt bölümleri: hem sol menüde hem sayfada kullanılır.
export const GROWTH_TABS = [
  ["opp", "Fırsatlar & Hatırlatma"], ["book", "Online Randevu"], ["coupon", "Kuponlar"], ["pkg", "Paketler & Abonelik"],
  ["loyal", "Sadakat"], ["score", "Teknisyen Karnesi"], ["stock", "Stok Siparişi"], ["price", "Fiyat & Rakip"],
  ["an", "Analiz & ROI"], ["aa", "Otomatik Atama"], ["brief", "Günlük Özet"], ["qr", "QR Etiket"], ["set", "Ayarlar"],
];
